import { axiosHelperWithToken } from "utils/axios";
// eslint-disable-next-line import/named
import { ThunkDispatch } from "redux-thunk";
import { showNotification } from "store/slices/snackbar/snackbarSlice";

export const fetchImages = (setImageData: Function, setExpanded: Function, id: string) => {
  return async (dispatch: ThunkDispatch<{}, {}, any>) => {
    const axios = axiosHelperWithToken();
    axios.get(`/Patient/images/${id}`).then((response) => {
      setImageData(response.data);
      setExpanded(Object.keys(response.data)[0]);
    }).catch(() => {
        dispatch(showNotification({ message: 'An error has occurred', variant: "error" }));
    });
  };
}
